var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherCoolStuffs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_440",
    "data-name": "Group 440",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 207.334,
    height: 215.108,
    viewBox: "0 0 207.334 215.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 207.334,
    height: 215.108,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4570",
    "data-name": "Path 4570",
    d: "M180.078,214.008,10.61,191.217A11.087,11.087,0,0,1,1.1,178.752L14.041,82.528A94.052,94.052,0,0,1,119.79,1.851l5.016.674a94.052,94.052,0,0,1,80.677,105.749L192.543,204.5a11.087,11.087,0,0,1-12.465,9.51",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4571",
    "data-name": "Path 4571",
    d: "M180.078,214.008,10.61,191.217A11.087,11.087,0,0,1,1.1,178.752L14.041,82.528A94.052,94.052,0,0,1,119.79,1.851l5.016.674a94.052,94.052,0,0,1,80.677,105.749L192.543,204.5A11.087,11.087,0,0,1,180.078,214.008Z",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4572",
    "data-name": "Path 4572",
    d: "M148.155,162.066,55.121,149.554a4.539,4.539,0,0,1-3.894-5.1l6.9-51.3a51.475,51.475,0,1,1,102.032,13.722l-6.9,51.3a4.539,4.539,0,0,1-5.1,3.894",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4573",
    "data-name": "Path 4573",
    d: "M148.155,162.066,55.121,149.554a4.539,4.539,0,0,1-3.894-5.1l6.9-51.3a51.475,51.475,0,1,1,102.032,13.722l-6.9,51.3A4.539,4.539,0,0,1,148.155,162.066Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4574",
    "data-name": "Path 4574",
    d: "M69.455,29.414l-1.7-2.954c-.613-1.067-1.281-1.1-1.9-.737s-.932.951-.318,2.016L67,30.294c1.791,3.109,6.789-.745,9.641,4.208l1.586,2.755c1.766,3.065.622,5.085-1.955,6.569s-4.875,1.447-6.64-1.618l-1.715-2.977,3.132-1.8,1.7,2.954c.614,1.066,1.282,1.1,1.927.724s.929-.95.316-2.016l-1.471-2.555c-1.791-3.109-6.767.732-9.62-4.222L62.321,29.56C60.555,26.494,61.7,24.475,64.254,23c2.576-1.485,4.853-1.435,6.619,1.631l1.714,2.976Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4575",
    "data-name": "Path 4575",
    d: "M80.229,19.63l2.163,6.683,3.366-1.089.963,2.974-3.366,1.09,2.181,6.731,3.438-1.114.979,3.025L82.93,40.2,75.664,17.768l7.023-2.275.98,3.024Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4576",
    "data-name": "Path 4576",
    d: "M93.885,16.618l.869,6.968,3.509-.438.387,3.1-3.51.437.876,7.019,3.585-.447.392,3.153-7.324.913-2.915-23.4,7.323-.913.394,3.154Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4577",
    "data-name": "Path 4577",
    d: "M120.675,19.01,119,33.477c-.413,3.565-2.583,4.475-5.563,4.13-2.954-.342-4.885-1.727-4.472-5.293l1.674-14.465c.413-3.567,2.608-4.474,5.563-4.132,2.98.345,4.885,1.727,4.472,5.293m-4.837-2.135c-.688-.079-1.315.209-1.457,1.432l-1.667,14.415c-.143,1.222.4,1.647,1.09,1.727.713.082,1.314-.21,1.456-1.432L116.928,18.6c.141-1.223-.377-1.644-1.09-1.727",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4578",
    "data-name": "Path 4578",
    d: "M134.37,19.848l-2.949-.533-3.632,20.076-3.733-.675,3.63-20.076-2.95-.534.566-3.128,9.634,1.743Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4579",
    "data-name": "Path 4579",
    d: "M151.266,22l-8.5,22-3.517-1.357,3.6-9.328-2.44-.941-3.6,9.327L133.3,40.346l8.5-22,3.516,1.357-3.75,9.709,2.439.943,3.75-9.71Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4580",
    "data-name": "Path 4580",
    d: "M159.442,30.368l-3.856,5.873,2.959,1.942L156.827,40.8l-2.957-1.944-3.886,5.915,3.022,1.986-1.746,2.657-6.172-4.054,12.95-19.718,6.173,4.054-1.747,2.658Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4581",
    "data-name": "Path 4581",
    d: "M158.382,56.028l3.93-6.269-1.119-1.13-5.119,5.066-2.649-2.679,16.762-16.585,4.055,4.1c2.489,2.514,2.009,4-.378,6.359L168.8,49.9a4.054,4.054,0,0,1-3.669,1.43l-4.352,7.118Zm5.953-8.379c.613.511,1.086.405,1.869-.37l5.066-5.012c.874-.865.893-1.354.119-2.138l-.793-.8-7.343,7.264Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4582",
    "data-name": "Path 4582",
    d: "M49.975,178.892c-.471,3.5-2.644,4.393-5.594,3.995-2.924-.392-4.809-1.827-4.339-5.331l1.933-14.369c.475-3.529,2.669-4.39,5.593-4,2.951.4,4.814,1.8,4.34,5.331l-.485,3.6-3.706-.5.482-3.58c.162-1.21-.345-1.637-1.051-1.732-.68-.092-1.308.183-1.47,1.393l-1.926,14.32c-.159,1.184.37,1.64,1.05,1.731.706.1,1.312-.208,1.471-1.392l.491-3.657,3.706.5Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4583",
    "data-name": "Path 4583",
    d: "M65.523,166.353,63.6,180.672c-.475,3.53-2.643,4.393-5.593,4-2.924-.394-4.813-1.8-4.339-5.332l1.926-14.32c.475-3.529,2.67-4.389,5.594-3.995,2.949.4,4.812,1.8,4.338,5.331m-4.759-2.205c-.681-.092-1.309.184-1.471,1.394L57.374,179.81c-.163,1.21.37,1.641,1.051,1.733.705.094,1.307-.184,1.47-1.394l1.919-14.269c.162-1.21-.345-1.637-1.05-1.732",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4584",
    "data-name": "Path 4584",
    d: "M79.19,168.191,77.264,182.51c-.475,3.53-2.644,4.393-5.593,4-2.924-.394-4.813-1.8-4.339-5.332l1.926-14.32c.475-3.529,2.669-4.389,5.593-3.995,2.949.4,4.813,1.8,4.339,5.331m-4.759-2.205c-.681-.092-1.309.184-1.471,1.394l-1.919,14.268c-.163,1.21.37,1.641,1.051,1.733.7.094,1.307-.184,1.47-1.394l1.919-14.269c.162-1.21-.345-1.637-1.05-1.732",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4585",
    "data-name": "Path 4585",
    d: "M88.46,185.35l-.421,3.126L80.4,187.449l3.12-23.193,3.706.5-2.7,20.067Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4586",
    "data-name": "Path 4586",
    d: "M105.265,175.111l.451-3.353c.163-1.209-.344-1.637-1.051-1.732s-1.306.184-1.469,1.394l-.39,2.9c-.475,3.529,5.788,3.524,5.031,9.146l-.42,3.126c-.467,3.479-2.59,4.374-5.514,3.981s-4.709-1.814-4.242-5.293l.455-3.378,3.554.478-.451,3.353c-.162,1.21.345,1.637,1.075,1.735s1.309-.182,1.471-1.392l.391-2.9c.474-3.529-5.764-3.521-5.008-9.142l.421-3.127c.467-3.479,2.591-4.374,5.489-3.984,2.924.393,4.685,1.811,4.217,5.29l-.455,3.378Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4587",
    "data-name": "Path 4587",
    d: "M122.055,172.62l-2.949-.4-2.7,20.067-3.732-.5,2.7-20.067-2.95-.4.42-3.125,9.631,1.295Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4588",
    "data-name": "Path 4588",
    d: "M133.417,190.062c-.475,3.529-2.645,4.393-5.594,4-2.924-.393-4.813-1.8-4.339-5.332l2.523-18.756,3.706.5L127.194,189.2c-.163,1.211.37,1.641,1.05,1.732.706.1,1.308-.183,1.471-1.392l2.518-18.731,3.706.5Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4589",
    "data-name": "Path 4589",
    d: "M142.985,175.435l-.949,7.06,3.528.474-.414,3.075-3.528-.474-1.336,9.932-3.732-.5,3.119-23.192,7.26.977-.42,3.125Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4590",
    "data-name": "Path 4590",
    d: "M153.978,176.913l-.949,7.06,3.529.474-.414,3.075-3.529-.474-1.336,9.932-3.731-.5,3.119-23.192,7.26.977-.42,3.125Z",
    fill: "#794d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4591",
    "data-name": "Path 4591",
    d: "M87.91,111.091c-1.978,8.45-5.256,18.493.431,26.361a15.1,15.1,0,0,0,4.49,3.47,17.912,17.912,0,0,0,5.114,1.7c13.728,1.623,27.923-7.175,35.236-18.416a40.163,40.163,0,0,0,4.767-10.81",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.966
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4592",
    "data-name": "Path 4592",
    d: "M84.793,109.861c1.227.6,7.88,1.2,8.568-.975",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.966
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4593",
    "data-name": "Path 4593",
    d: "M142.064,111.516a3.637,3.637,0,0,1-6.715-.72",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.966
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4594",
    "data-name": "Path 4594",
    d: "M99.33,95.6a11.009,11.009,0,0,0,.28,1.178c.607,2.025,1.481,4.305,3.117,2.5,1.2-1.319,1.534-4.579,1.751-6.276,1.1-8.622-2.79-17.308-9-23.176-.608-.484-3.608-.142-3.936,1.829a5.49,5.49,0,0,0,.948,3.484,68.351,68.351,0,0,1,5.626,9.541c1.528,3.467.562,7.31,1.219,10.917",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4595",
    "data-name": "Path 4595",
    d: "M109.739,99.294c0,1.238-.662,2.695-.085,2.906,1.519,1.208,3.67.687,5.641,1.016.2-1.865.372-3.749.491-5.641s.195-3.786.2-5.676c-.078-7.541.684-17.85-5.751-20.986-4.1-2.021-1.952,7.129-1.263,11.2a53.769,53.769,0,0,1,1.127,8.215,59.088,59.088,0,0,1-.365,8.963",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4596",
    "data-name": "Path 4596",
    d: "M137.681,67.345l3.174,1.893-3.306,1.651-1.893,3.174-1.651-3.306-3.174-1.893,3.306-1.651,1.893-3.174Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4597",
    "data-name": "Path 4597",
    d: "M140.528,77.869l1.458.87-1.519.758-.87,1.459-.758-1.519-1.458-.87,1.519-.759.869-1.458Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherCoolStuffs);
export default __webpack_public_path__ + "static/media/other-cool-stuffs.66982c377fac4cba8d00dd2923883272.svg";
export { ForwardRef as ReactComponent };